import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { actions } from '../constants/free_mobile_fitting_light_box/actions';

class FreeMobileFittingLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
        };
    }

    reduce( state, { source, action } ) {
        const { type } = action;

        if (source === ACTION_TYPES.FREE_MOBILE_FITTING_LIGHT_BOX_ACTION) {
            switch ( type ) {
                case actions.SHOW:
                    if ( !state.visible ) {
                        state.visible = true;
                        this.__emitChange();
                    }
                    break;

                case actions.HIDE:
                    if ( state.visible ) {
                        state.visible = false;
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}

const FreeMobileFittingLightBoxStore = new FreeMobileFittingLightBoxStoreClass( Dispatcher );
export { FreeMobileFittingLightBoxStore };
